import { ItemSubtypes, ItemTypes } from "lib/types/items";

export const checkOsCompatibility = (
  supportedOs: string[],
  userOs: string[],
  assetType: ItemTypes,
  assetSubtype?: ItemSubtypes
): boolean => {
  if (assetType === ItemTypes.HARDWARE) return true;
  if (assetSubtype === ItemSubtypes.CLOUD) return true;

  return supportedOs.length === 0 || supportedOs.some((os) => userOs.includes(os));
};
